import { h } from 'vue';
import type { CmsElementReplacer } from '@nuxt-shared/ui/cms-content';
import ChartWidget from '../ChartWidget.vue';
import type { ChartWidgetProps } from '../types';
import { isChartElement, parseChartAttrs } from './parseChartAttrs';

/**
 * Правило подстановки графика в редакторский HTML.
 *
 * Отдаётся страницами в проп `elements` компонента `CmsContent` (и в
 * лендинговый конвертер): `<div data-charts="…">` из конструктора админки
 * становится виджетом графика, всё остальное рендерится как обычно.
 *
 * @param defaults пропсы, которые страница хочет задать поверх data-атрибутов
 *                 (например, выключить переключатели: `{ controls: false }`)
 */
export function createChartElementReplacer(
  defaults: Partial<ChartWidgetProps> = {},
): CmsElementReplacer {
  return {
    match: isChartElement,
    render: (el) => {
      const props = parseChartAttrs(el);

      // Кодов графиков нет — блок остаётся обычным `div`.
      if (!props) return undefined;

      return h(ChartWidget, { ...props, ...defaults });
    },
  };
}

/** Готовое правило с настройками по умолчанию. */
export const chartElementReplacer: CmsElementReplacer = createChartElementReplacer();

/**
 * Готовый набор правил для пропа `elements`.
 *
 * Константа, а не литерал в шаблоне: новый массив на каждый рендер заставлял бы
 * `CmsContent` пересобирать всё дерево контента.
 */
export const chartElements: CmsElementReplacer[] = [chartElementReplacer];
